import { render, staticRenderFns } from "./ImageDetail.vue?vue&type=template&id=3f9e60cc&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"
import style0 from "./ImageDetail.vue?vue&type=style&index=0&id=3f9e60cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e60cc",
  null
  
)

export default component.exports